var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"47267bcf71b1d46cafcb4ed573ea76946e11b1db"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prod-songwhip-web@the-orchard"]={id:"47267bcf71b1d46cafcb4ed573ea76946e11b1db"};
      